import { render } from "./FilterbarChallengeList.vue?vue&type=template&id=1a009726&scoped=true"
import script from "./FilterbarChallengeList.vue?vue&type=script&lang=js"
export * from "./FilterbarChallengeList.vue?vue&type=script&lang=js"

import "@/css/components/filterbar-challenge-list.css?vue&type=style&index=0&id=1a009726&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a009726"]])

export default __exports__